import iconFail from "assets/img/icons/icon-warning.svg";

const ClaimPrizeFail = ({ close }) => {
  return (
    <>
      <header className="modal-window__header">
        <img src={iconFail} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Something went wrong</h5>
        <p className="modal-window__info">Claiming prize was not completed.</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={close}>Done</button>
      </footer>
    </>
  );
};

export default ClaimPrizeFail;
